import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/petugas',
    name: 'petugas',
    component: () => lazyLoadView(import('@views/admin/operator/loket/List.vue')),
    meta: {
      title: 'Petugas',
    },
  },
  {
    path: '/:operator/:id(\\d+)/petugas/:operator_id(\\d+)',
    name: 'petugas-detil',
    component: () => lazyLoadView(import('@views/admin/operator/loket/Detail.vue')),
    meta: {
      title: 'Detil Petugas',
    },
  },
];
